import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_CHATURL } from '../../components/constants';
import { authHeader } from '../../utils/authHeaders';

export const fetchChatHistory = createAsyncThunk(
  'history/fetchChatHistory',
  async ({ historyId, userId }) => {
    const response = await axios.get(`${BASE_CHATURL}/get-chat-history/${historyId}/${userId}`, {
      headers: { ...authHeader() },
    });
    return response.data;
  }
);

export const fetchChatHistoryByUser = createAsyncThunk(
  'history/fetchChatHistoryByUser',
  async (userId) => {
    const response = await axios.get(`${BASE_CHATURL}/get-chat-history-by-user/${userId}`, {
      headers: { ...authHeader() },
    });
    return response.data.history_records;
  }
);

const historySlice = createSlice({
  name: 'history',
  initialState: {
    chatHistory: [],
    userHistories: [], // All user's project histories for recent projects
    status: 'idle',
    error: null,
    userHistoriesStatus: 'idle',
    userHistoriesError: null,
  },
  reducers: {
    // Local patches so create/rename/delete don't need a full refetch of
    // userHistories — mirrors taskSlice.js's createTaskAsync/updateTaskAsync/
    // deleteTaskAsync reducers.
    projectCreated: (state, action) => {
      state.userHistories.push(action.payload);
    },
    projectRenamed: (state, action) => {
      const { id, history_name } = action.payload;
      const item = state.userHistories.find((h) => h.id === id);
      if (item) item.history_name = history_name;
    },
    projectDeleted: (state, action) => {
      const ids = Array.isArray(action.payload) ? action.payload : [action.payload];
      state.userHistories = state.userHistories.filter((h) => !ids.includes(h.id));
    },
    analysisModeChanged: (state, action) => {
      const { id, on } = action.payload;
      const record = state.chatHistory?.history_records;
      if (record && record.id === id) record.analysis_mode_on = on;
    },
  },
  extraReducers: {
    [fetchChatHistory.pending]: (state, action) => {
      state.status = 'loading';
    },
    [fetchChatHistory.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.chatHistory = action.payload;
    },
    [fetchChatHistory.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = action.error.message;
    },
    [fetchChatHistoryByUser.pending]: (state, action) => {
      state.userHistoriesStatus = 'loading';
    },
    [fetchChatHistoryByUser.fulfilled]: (state, action) => {
      state.userHistoriesStatus = 'succeeded';
      state.userHistories = action.payload; // Store in separate state
    },
    [fetchChatHistoryByUser.rejected]: (state, action) => {
      state.userHistoriesStatus = 'failed';
      state.userHistoriesError = action.error.message;
    },
  },
});

export const { projectCreated, projectRenamed, projectDeleted, analysisModeChanged } = historySlice.actions;
export default historySlice.reducer;
